import { Component, OnInit } from '@angular/core';
import {KursanciService} from "../services/kursanci.service";
import {ActivatedRoute} from "@angular/router";

@Component({
  selector: 'app-grupa-new',
  templateUrl: './grupa-new.component.html',
  styleUrls: ['./grupa-new.component.scss']
})
export class GrupaNewComponent implements OnInit {

    kursantId: string;

    constructor(private kursanciService: KursanciService, route: ActivatedRoute) {

        this.kursantId = route.snapshot.queryParams['kursantId'];
    }

    ngOnInit() {
    }

    zapisz(formGrupa) {
        this.kursanciService.dodajGrupe(formGrupa.value)
            .subscribe(
                () => {
                    alert("Grupa dodana. Dodaj następną.");
                    formGrupa.reset();
                },
                err => alert(`Błąd. Nie udało się dodać grupy. ${err}`)
            );

    }

}


// WEBPACK FOOTER //
// ./src/app/grupa-new/grupa-new.component.ts